import { gql } from "@apollo/client";

const componentGroupToolbarFragment = gql`
    fragment ComponentGroupToolbar on ComponentGroup {
        id
        code
        description
        componentType
    }
`;

export const usageListToolbarQuery = gql`
    query UsageListToolbar {
        componentGroups(limit: 100, sort: [{ field: code, direction: ASC }]) {
            nodes {
                ...ComponentGroupToolbar
            }
        }

        modelSpecifications {
            nodes {
                id
                name
            }
        }
    }
    ${componentGroupToolbarFragment}
`;
